import React, {FC} from 'react';
import {RouterProvider, createBrowserRouter} from 'react-router-dom';
import './App.css';
import EventPage from './components/EventPage/EventPage';
import {ApolloClient, ApolloLink, HttpLink, InMemoryCache} from '@apollo/client';
import {ApolloProvider} from '@apollo/client/react';
import {SetContextLink} from '@apollo/client/link/context';

import {Box, ThemeProvider, createTheme} from '@mui/material';
import {cyan} from '@mui/material/colors';
import logo from './livezone_logo.png?inline';

import LoginPage from './components/Auth/LoginPage';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const httpLink = new HttpLink({
  uri: import.meta.env.VITE_GRAPHQL
});

const authLink = new SetContextLink((prevContext) => {
  const accessToken = localStorage.getItem('access_token');
  return {
    headers: {
      ...prevContext.headers,
      authorization: accessToken ? `Bearer ${accessToken}` : ''
    }
  };
});

const apolloClient = new ApolloClient({
  link: ApolloLink.from([authLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      LiveEvent: {
        keyFields: ['slug', 'sub']
      }
    }
  })
});

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#ff2d78'
    },
    secondary: {
      main: cyan[500]
    }
  },
  typography: {
    fontFamily: 'Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    button: {
      textTransform: 'none'
    }
  },
  shape: {
    borderRadius: 10
  }
});

const App: FC = () => {
  const routes = [
    {
      path: '/',
      element: (
        <Box className="event-shell" sx={{ alignItems: 'center', justifyContent: 'center' }}>
          <Box sx={{ height: 'auto', px: 5, py: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Box component="img" src={logo} alt="LiveZone" sx={{ height: 36 }} />
            <Box sx={{ color: '#6b7280', fontWeight: 600 }}>Open an event link to follow the race.</Box>
          </Box>
        </Box>
      )
    },
    {
      path: '/login',
      element: <LoginPage />
    },
    {
      path: '/:slug',
      element: <EventPage />
    },
    {
      path: '/:slug/:sub',
      element: <EventPage />
    }
  ];
  const router = createBrowserRouter(routes);

  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={defaultTheme}>
        <RouterProvider router={router} />
        <ToastContainer position="top-center" autoClose={3000} theme="light" />
      </ThemeProvider>
    </ApolloProvider>
  );
};

export default App;
